import { createContext } from 'react';

export type WithdrawAccountCtx = {
  showWithdrawAccountErrorAlert: boolean;
  withdrawAccountError: string;
};

const WithdrawAccountDialogueContext = createContext<WithdrawAccountCtx>({
  showWithdrawAccountErrorAlert: false,
  withdrawAccountError: '',
});

export default WithdrawAccountDialogueContext;